
{
  "familyId": "TAA-ONT-VOORZETSEL",
  "questions": [
    {
      "id": "TAA-ONT-VOORZETSEL-001",
      "familyId": "TAA-ONT-VOORZETSEL",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Wat is het voorzetselvoorwerp in de zin: 'De kinderen wachten op de bus.'?",
      "options": ["op de bus", "De kinderen", "wachten", "de bus"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 1,
        "plusstof": true,
        "plusstofNote": "Voorzetselvoorwerp is plusstof: op de basisschool meestal benoemd als bijwoordelijke bepaling. Volledige benoeming hoort bij eind groep 8 / VO.",
        "misconceptionTags": [
          { "id": "taa.lidwoord-als-vz", "label": "Lidwoord verward met voorzetsel", "optionIndex": 1 },
          { "id": "taa.zelfst-naamwoord-als-vz", "label": "Zelfstandig naamwoord verward met voorzetsel", "optionIndex": 2 },
          { "id": "taa.werkwoord-als-vz", "label": "Werkwoord verward met voorzetsel", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorzetselvoorwerp herkennen (PLUSSTOF — eind groep 8 / VO)",
            "content": "Let op: het voorzetselvoorwerp is plusstof; op de basisschool wordt dit zinsdeel meestal benoemd als bijwoordelijke bepaling. Een voorzetselvoorwerp begint met een vast voorzetsel dat bij het werkwoord hoort. Vraag: 'Waar wacht je OP?' → 'op de bus' is het voorzetselvoorwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voorzetselvoorwerp_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het werkwoord 'wachten' hoort bij het vaste voorzetsel 'op'. Vraag: waar wacht je op? → op de bus. Het hele stuk 'op de bus' is het voorzetselvoorwerp.",
        "solutionSteps": [
          "Zoek het werkwoord: wachten",
          "Welk voorzetsel hoort bij 'wachten'? → op",
          "Stel de vraag: waar wacht je op? → op de bus",
          "Het voorzetselvoorwerp is: op de bus"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Op de bus' is het voorzetselvoorwerp. Het voorzetsel 'op' hoort vast bij 'wachten'.",
          "1": "Je dacht waarschijnlijk dat het onderwerp werd gevraagd. 'De kinderen' is het onderwerp (wie wacht?), maar het voorzetselvoorwerp is het zinsdeel dat begint met het vaste voorzetsel. Onthoud: zoek eerst het vaste voorzetsel bij het werkwoord.",
          "2": "Je dacht waarschijnlijk dat het werkwoord werd gevraagd. 'Wachten' is de persoonsvorm, niet het voorzetselvoorwerp. Onthoud: het voorzetselvoorwerp is een zinsdeel, niet het werkwoord zelf.",
          "3": "Je dacht waarschijnlijk dat alleen 'de bus' het antwoord is. Maar het voorzetsel 'op' hoort erbij! Het hele stuk 'op de bus' is het voorzetselvoorwerp. Onthoud: het voorzetsel is onderdeel van het voorzetselvoorwerp."
        }
      }
    },
    {
      "id": "TAA-ONT-VOORZETSEL-002",
      "familyId": "TAA-ONT-VOORZETSEL",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_voorzetsel",
      "questionType": "multiple_choice",
      "question": "In welke zin staat een voorzetselvoorwerp?",
      "options": ["Ik denk aan mijn oma.", "Ik loop naar school.", "De kat zit op de mat.", "Hij rent door het park."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorzetselvoorwerp vs. bijwoordelijke bepaling",
            "content": "Een voorzetselvoorwerp heeft een VAST voorzetsel bij het werkwoord. 'Denken AAN' is vast — je kunt 'aan' niet weglaten. 'Lopen naar school' is een bijwoordelijke bepaling van plaats — 'naar' is niet vast bij 'lopen'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voorzetselvoorwerp_vs_bwb",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "plusstof": true,
        "plusstofNote": "Onderscheid voorzetselvoorwerp/bijwoordelijke bepaling = plusstof.",
        "misconceptionTags": [
          { "id": "taa.vzv-bwb-als-vzv", "label": "Bijwoordelijke bepaling verward met voorzetselvoorwerp", "optionIndex": 1 },
          { "id": "taa.vzv-niet-vast-voorzetsel", "label": "Niet-vast voorzetsel aangezien voor vast", "optionIndex": 2 },
          { "id": "taa.vzv-bwb-als-vzv", "label": "Bijwoordelijke bepaling verward met voorzetselvoorwerp", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Denken' heeft het vaste voorzetsel 'aan'. Je kunt niet zeggen 'ik denk mijn oma' — het voorzetsel 'aan' is verplicht. Dus 'aan mijn oma' is een voorzetselvoorwerp. De andere zinnen hebben bijwoordelijke bepalingen van plaats.",
        "solutionSteps": [
          "Check elk werkwoord: heeft het een vast voorzetsel?",
          "'Denken aan' → vast voorzetsel ✓",
          "'Lopen naar' → niet vast (je kunt ook 'lopen in het bos' zeggen)",
          "'Zitten op' → niet vast (je kunt ook 'zitten in de stoel' zeggen)",
          "'Rennen door' → niet vast (je kunt ook 'rennen over het veld' zeggen)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Denken aan' is een vast voorzetsel. 'Aan mijn oma' is het voorzetselvoorwerp.",
          "1": "Je dacht waarschijnlijk dat 'naar school' een voorzetselvoorwerp is. Maar 'naar' is niet vast bij 'lopen' — je kunt ook 'lopen in het bos' zeggen. 'Naar school' is een bijwoordelijke bepaling van plaats. Onthoud: bij een voorzetselvoorwerp kun je het voorzetsel NIET vervangen.",
          "2": "Je dacht waarschijnlijk dat 'op de mat' een voorzetselvoorwerp is. Maar 'op' is niet vast bij 'zitten' — je kunt ook 'zitten in de stoel' zeggen. Onthoud: test of het voorzetsel vervangbaar is. Zo ja → bijwoordelijke bepaling.",
          "3": "Je dacht waarschijnlijk dat 'door het park' een voorzetselvoorwerp is. Maar 'door' is niet vast bij 'rennen'. Onthoud: een voorzetselvoorwerp heeft een VAST voorzetsel dat je niet kunt weglaten of vervangen."
        }
      }
    },
    {
      "id": "TAA-ONT-VOORZETSEL-003",
      "familyId": "TAA-ONT-VOORZETSEL",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Welk voorzetsel hoort vast bij het werkwoord 'lijken'?",
      "options": ["op", "aan", "met", "voor"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vaste voorzetsels",
            "content": "Sommige werkwoorden hebben een vast voorzetsel: lijken OP, denken AAN, houden VAN, wachten OP, zorgen VOOR. Je kunt dit testen door te vragen: 'Waar lijkt het OP?'",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vast_voorzetsel_herkennen",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "plusstof": true,
        "plusstofNote": "Benoemen van vaste voorzetsels bij werkwoorden hoort bij plusstof / VO-voorbereiding.",
        "misconceptionTags": [
          { "id": "taa.vzv-verkeerd-voorzetsel-bij-werkwoord", "label": "Verkeerd vast voorzetsel bij werkwoord", "optionIndex": 1 },
          { "id": "taa.vzv-verkeerd-voorzetsel-bij-werkwoord", "label": "Verkeerd vast voorzetsel bij werkwoord", "optionIndex": 2 },
          { "id": "taa.vzv-verkeerd-voorzetsel-bij-werkwoord", "label": "Verkeerd vast voorzetsel bij werkwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Het werkwoord 'lijken' heeft het vaste voorzetsel 'op'. Je zegt: 'Het lijkt OP een vlinder.' Je kunt niet zeggen: 'Het lijkt aan een vlinder.'",
        "solutionSteps": [
          "Maak een zin met 'lijken': 'Het lijkt op een vlinder.'",
          "Test: kun je 'op' vervangen? 'Het lijkt aan een vlinder' → klinkt fout",
          "Dus 'op' is het vaste voorzetsel bij 'lijken'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Lijken op' is de vaste combinatie. Je zegt: 'Het lijkt op een vlinder.'",
          "1": "Je dacht waarschijnlijk aan 'denken aan'. Maar bij 'lijken' zeg je 'lijken OP', niet 'lijken aan'. Onthoud: elk werkwoord heeft zijn eigen vaste voorzetsel.",
          "2": "Je dacht waarschijnlijk aan 'praten met'. Maar bij 'lijken' zeg je 'lijken OP', niet 'lijken met'. Onthoud: test het door een zin te maken.",
          "3": "Je dacht waarschijnlijk aan 'zorgen voor'. Maar bij 'lijken' zeg je 'lijken OP', niet 'lijken voor'. Onthoud: maak een voorbeeldzin om het vaste voorzetsel te vinden."
        }
      }
    },
    {
      "id": "TAA-ONT-VOORZETSEL-004",
      "familyId": "TAA-ONT-VOORZETSEL",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Wat is het voorzetselvoorwerp in: 'Sara houdt van chocolade.'?",
      "options": ["van chocolade", "Sara", "houdt", "chocolade"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 1,
        "plusstof": true,
        "plusstofNote": "Voorzetselvoorwerp is plusstof: op de basisschool meestal benoemd als bijwoordelijke bepaling.",
        "misconceptionTags": [
          { "id": "taa.lidwoord-als-vz", "label": "Lidwoord verward met voorzetsel", "optionIndex": 1 },
          { "id": "taa.zelfst-naamwoord-als-vz", "label": "Zelfstandig naamwoord verward met voorzetsel", "optionIndex": 2 },
          { "id": "taa.werkwoord-als-vz", "label": "Werkwoord verward met voorzetsel", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorzetselvoorwerp vinden",
            "content": "Stap 1: Zoek het werkwoord (houdt). Stap 2: Welk voorzetsel hoort erbij? (van). Stap 3: Stel de vraag: waar houdt Sara van? → van chocolade.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voorzetselvoorwerp_houden_van",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Houden van' is een vaste combinatie. Vraag: waar houdt Sara van? → van chocolade. Het hele stuk 'van chocolade' is het voorzetselvoorwerp.",
        "solutionSteps": [
          "Zoek het werkwoord: houden",
          "Vast voorzetsel bij 'houden': van",
          "Vraag: waar houdt Sara van? → van chocolade",
          "Voorzetselvoorwerp = van chocolade"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Van chocolade' is het voorzetselvoorwerp. Het voorzetsel 'van' hoort vast bij 'houden'.",
          "1": "Je dacht waarschijnlijk dat het onderwerp werd gevraagd. 'Sara' is het onderwerp, niet het voorzetselvoorwerp. Onthoud: het voorzetselvoorwerp begint met het vaste voorzetsel.",
          "2": "Je dacht waarschijnlijk dat 'houdt van' samen het antwoord is. Maar 'houdt' is het werkwoord en 'van chocolade' is het voorzetselvoorwerp. Het werkwoord hoort niet bij het voorzetselvoorwerp. Onthoud: het voorzetselvoorwerp is een apart zinsdeel.",
          "3": "Je dacht waarschijnlijk dat alleen 'chocolade' het antwoord is. Maar het voorzetsel 'van' hoort erbij! Onthoud: het voorzetselvoorwerp = voorzetsel + de rest."
        }
      }
    },
    {
      "id": "TAA-ONT-VOORZETSEL-005",
      "familyId": "TAA-ONT-VOORZETSEL",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_voorzetsel",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het vaste voorzetsel dat erbij hoort.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["denken", "wachten", "houden", "zorgen"],
        "rightItems": ["van", "op", "aan", "voor"],
        "correctMatches": { "0": 2, "1": 1, "2": 0, "3": 3 }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vaste voorzetsels onthouden",
            "content": "Maak een voorbeeldzin: 'Ik denk AAN jou', 'Ik wacht OP de trein', 'Ik houd VAN muziek', 'Ik zorg VOOR mijn hond'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vast_voorzetsel_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "plusstof": true,
        "plusstofNote": "Koppelen van vaste voorzetsels is plusstof / VO-voorbereiding."
      },
      "feedback": {
        "explanationText": "Denken AAN, wachten OP, houden VAN, zorgen VOOR. Maak altijd een voorbeeldzin om het vaste voorzetsel te vinden.",
        "solutionSteps": [
          "Denken → 'Ik denk AAN jou' → aan",
          "Wachten → 'Ik wacht OP de bus' → op",
          "Houden → 'Ik houd VAN muziek' → van",
          "Zorgen → 'Ik zorg VOOR mijn hond' → voor"
        ]
      }
    }
  ]
}
